export default class MathHelper {
	static radiansToDegress = function (radians) {
		return radians * (180 / Math.PI);
	}

	static degreesToRadians = function (degrees) {
		return degrees * (Math.PI / 180);
	}

	static splitToNChunks(array, n) {
		let result = [];
		for (let i = n; i > 0; i--) {
			result.push(array.splice(0, Math.ceil(array.length / i)));
		}
		return result;
	}

	static getFastDistanceToSquared(pos1, pos2) {
		const cx = pos2.x;
		const cy = pos2.y;
		const cz = pos2.z;

		const dx = cx - pos1.x;
		const dy = cy - pos1.y;
		const dz = cz - pos1.z;
		const distSq = dx * dx + dy * dy + dz * dz;
		return distSq;
	}
}
